// Simple event emitter for favorites synchronization across components
type FavoritesListener = () => void;

class FavoritesEventEmitter {
  private listeners: Set<FavoritesListener> = new Set();

  on(listener: FavoritesListener): void {
    if (this.listeners.has(listener)) {
      console.warn('[FavoritesEventEmitter] Listener already registered.');
      return;
    }
    console.debug(
      '[FavoritesEventEmitter] Registering listener, total listeners:',
      this.listeners.size + 1,
    );
    console.trace('[FavoritesEventEmitter] Listener registration stack trace');
    this.listeners.add(listener);
  }

  off(listener: FavoritesListener): void {
    if (!this.listeners.has(listener)) {
      console.warn('[FavoritesEventEmitter] Attempted to unregister a non-existent listener.');
      return;
    }
    console.debug(
      '[FavoritesEventEmitter] Unregistering listener, total listeners:',
      this.listeners.size - 1,
    );
    this.listeners.delete(listener);
  }

  emit(): void {
    console.debug('[FavoritesEventEmitter] Emitting event to', this.listeners.size, 'listeners');
    if (this.listeners.size === 0) {
      console.warn('[FavoritesEventEmitter] WARNING: No listeners registered!');
    }
    this.listeners.forEach((listener) => listener());
  }
}

export const favoritesEventEmitter = new FavoritesEventEmitter();
